import { Monitor, Moon, Sun } from 'lucide-react';
import { useTheme, type ThemeChoice } from '../theme/ThemeProvider';

// Compact 3-segment control: Light / Dark / System. Sized to drop into the
// avatar dropdown without crowding it. Doesn't close the parent menu on
// click — flipping themes is a quick adjustment, not a navigation.

const SEGMENTS: Array<{ value: ThemeChoice; icon: typeof Sun; label: string }> = [
  { value: 'light', icon: Sun, label: 'Light' },
  { value: 'dark', icon: Moon, label: 'Dark' },
  { value: 'system', icon: Monitor, label: 'System' },
];

export function ThemeToggle() {
  const { choice, setChoice } = useTheme();
  return (
    <div className="px-2 py-1.5">
      <div className="mb-1.5 px-1 text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
        Theme
      </div>
      <div
        role="group"
        aria-label="Theme"
        className="grid grid-cols-3 gap-1 rounded-md border bg-muted/30 p-0.5"
      >
        {SEGMENTS.map((s) => {
          const Icon = s.icon;
          const active = choice === s.value;
          return (
            <button
              key={s.value}
              type="button"
              onClick={(e) => {
                // Prevent the dropdown from interpreting this as a menu-item
                // selection (which would close the menu).
                e.stopPropagation();
                setChoice(s.value);
              }}
              aria-pressed={active}
              className={`flex items-center justify-center gap-1.5 rounded-sm px-2 py-1 text-xs font-medium transition-colors ${
                active
                  ? 'bg-background text-foreground shadow-sm'
                  : 'text-muted-foreground hover:bg-background/60 hover:text-foreground'
              }`}
            >
              <Icon className="h-3.5 w-3.5" />
              <span>{s.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
